@if (!editMode) {
  <h2 mat-dialog-title class="dialog-title">
    Modul Zeit-Verformungsgraphik NEU hinzufügen
  </h2>
}
@if (editMode) {
  <h2 mat-dialog-title class="dialog-title">
    Modul Zeit-Verformungsgraphik NEU editieren
  </h2>
}

<mat-dialog-content class="dialog-content">
  <form
    [formGroup]="correlationForm"
    (ngSubmit)="updateOrCreateModule()"
    ngNativeValidate
    class="config-form"
    >
    <!-- Section 1: Basic Configuration -->
    <section class="config-section">
      <div class="section-header">
        <h5 class="section-title">Konfiguration Graphik</h5>
        <mat-slide-toggle formControlName="relativeZero" class="section-toggle">
          <span class="section-toggle-label">
            Darstellung der relativen Verformung erlauben
          </span>
        </mat-slide-toggle>
      </div>

      <div class="section-content">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Überschrift</mat-label>
          <input matInput formControlName="headline" required />
          @if (correlationForm.controls.headline.hasError('required')) {
            <mat-error
              >
              Überschrift angeben
            </mat-error>
          }
        </mat-form-field>

        <div class="form-row">
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>X-Achse Beschriftung</mat-label>
            <input matInput formControlName="labelXAxis" required />
            @if (correlationForm.controls.labelXAxis.hasError('required')) {
              <mat-error
                >
                Beschriftung für X-Achse angeben
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Y-Achse Beschriftung</mat-label>
            <input matInput formControlName="labelYAxis" required />
            @if (correlationForm.controls.labelYAxis.hasError('required')) {
              <mat-error
                >
                Beschriftung für Y-Achse angeben
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </section>

    <!-- Section 2: Time Period Filter -->
    <section class="config-section">
      <div class="section-header">
        <h5 class="section-title">Zeitraum Filter</h5>
        <mat-slide-toggle
          formControlName="timePeriodFiltered"
          class="section-toggle"
          >
          <span class="section-toggle-label">
            Daten zwischen bestimmten Uhrzeiten anzeigen
          </span>
        </mat-slide-toggle>
      </div>

      @if (correlationForm.get('timePeriodFiltered').value) {
        <div
          class="section-content"
          >
          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Filter Start [Stunde]</mat-label>
              <input
                [attr.disabled]="timeFilterDisabled"
                matInput
                formControlName="timePeriodFilteredFrom"
                type="number"
                min="0"
                max="23"
                />
              @if (
                correlationForm.controls.timePeriodFilteredFrom.hasError(
                'validTime'
                )
                ) {
                <mat-error
                  >
                  Zeitraum im Format [hh] angeben
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Filter Ende [Stunde]</mat-label>
              <input
                [attr.disabled]="timeFilterDisabled"
                matInput
                formControlName="timePeriodFilteredTill"
                type="number"
                min="0"
                max="23"
                />
              @if (
                correlationForm.controls.timePeriodFilteredTill.hasError(
                'validTime'
                )
                ) {
                <mat-error
                  >
                  Zeitraum im Format [hh] angeben
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
    </section>

    <!-- Section 2b: Default Display Date Range -->
    <section class="config-section">
      <div class="section-header">
        <h5 class="section-title">{{ "app.defaultDisplayTimePeriod" | translate }}</h5>
      </div>
      <app-default-date-range-selector
        [parentForm]="correlationForm"
      ></app-default-date-range-selector>
    </section>

    <!-- Section 2c: Default Smoothing Period -->
    <section class="config-section">
      <div class="section-header">
        <h5 class="section-title">{{ "app.defaultSmoothingTimePeriod" | translate }}</h5>
      </div>
      <app-default-smoothing-selector
        [parentForm]="correlationForm"
      ></app-default-smoothing-selector>
    </section>

    <!-- Section 3: Data Selection -->
    <section class="config-section">
      <h5 class="section-title">Auswahl Daten</h5>
      <div formArrayName="sensorFields" class="section-content">
        @for (fieldCtrl of sensorFields.controls; track fieldCtrl; let i = $index) {
          <div
            [formGroupName]="i"
            class="sensor-field-item"
            >
            <div class="field-header">
              <mat-checkbox
                formControlName="allSelected"
                (change)="onAllSelectedChange(i, $event.checked)"
                class="field-checkbox"
                >
                {{ fieldCtrl.value.displayName }}
              </mat-checkbox>
              <div class="field-actions">
                <button
                  mat-icon-button
                  matTooltip="Sensor-Auswahl kopieren"
                  (click)="copyFieldSelection(i)"
                  class="copy-button"
                  type="button"
                  >
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matTooltip="Sensor-Auswahl einfügen"
                  (click)="pasteFieldSelection(i)"
                  [disabled]="!hasCopiedField()"
                  class="paste-button"
                  type="button"
                  >
                  <mat-icon>content_paste</mat-icon>
                </button>
              </div>
            </div>
            <mat-accordion class="sensor-accordion">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{
                    selectedStationsForField(sensorControlsForField(fieldCtrl))
                    }}
                    / {{ sensorControlsForField(fieldCtrl).length }} Stationen
                    ausgewählt
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div formArrayName="sensors" class="sensor-list">
                  @for (
                    sensorCtrl of sensorControlsForField(fieldCtrl); track
                    sensorCtrl; let j = $index) {
                    <div
                      [formGroupName]="j"
                      class="sensor-item"
                      >
                      <mat-checkbox
                        formControlName="checked"
                        (change)="onSensorChange(i, j)"
                        >
                        {{ sensorCtrl.get("name").value }}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
      </div>
    </section>

    <!-- Section 4: Y-Axis Min/Max Values -->
    <section class="config-section">
      <h5 class="section-title">Minimal- und Maximalwert Ordinate</h5>
      <div class="section-content">
        <ng-container formArrayName="yAxisMinValues">
          @for (
            field of correlationForm.get('yAxisMinValues')['controls']
            | MinMaxOrdinateFilter : selectedFields; track
            field; let i = $index) {
            <div
              class="min-max-row"
              >
              <div [formGroup]="field" class="min-max-form">
                <div class="field-label">
                  <mat-label>{{
                    sensorInfoForId(field.value.id).label
                  }}</mat-label>
                </div>
                <div class="min-max-inputs">
                  <mat-form-field appearance="outline" class="min-input">
                    <mat-label
                      >Min [{{ sensorInfoForId(field.value.id).unit }}]</mat-label
                      >
                      <input
                        step="0.0001"
                        type="number"
                        matInput
                        formControlName="min"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="max-input">
                      <mat-label
                        >Max [{{ sensorInfoForId(field.value.id).unit }}]</mat-label
                        >
                        <input
                          step="0.0001"
                          type="number"
                          matInput
                          formControlName="max"
                          />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              }
            </ng-container>
          </div>
        </section>

        <!-- Section 5: Default Parameter -->
        <section class="config-section">
          <h5 class="section-title">{{ "app.defaultSelectedParameter" | translate }}</h5>
          <div class="section-content">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Default Feld</mat-label>
              <mat-select
                [formControl]="defaultSelectedFieldControl"
                name="defaultSelectedField"
                >
                @for (field of selectedFields; track field) {
                  <mat-option
                    [value]="field.fieldName"
                    required
                    >
                    {{ sensorInfoForId(field.fieldName).label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </section>

        <!-- Section 6: Second Y-Axis -->
        <section class="config-section">
          <div class="section-header">
            <h5 class="section-title">Zweite Y-Achse</h5>
            <mat-slide-toggle
              [formControl]="correlationForm.get('secondYAxis.enabled')"
              (change)="onSecondYAxisEnabledChange($event.checked)"
              class="section-toggle"
              >
              <span class="section-toggle-label">Zweite Y-Achse aktivieren</span>
            </mat-slide-toggle>
          </div>

          @if (correlationForm.get('secondYAxis.enabled').value) {
            <div
              formGroupName="secondYAxis"
              class="section-content"
              >
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Sensor auswählen</mat-label>
                <mat-select
                  formControlName="sensor"
                  (selectionChange)="onSecondYAxisSensorChange($event.value)"
                  >
                  @for (sensor of availableSensorsForSecondYAxis; track sensor) {
                    <mat-option
                      [value]="sensor"
                      >
                      {{ sensor.display_name }}
                    </mat-option>
                  }
                </mat-select>
                @if (secondYAxisFormGroup.get('sensor').hasError('required')) {
                  <mat-error
                    >
                    Sensor für zweite Y-Achse auswählen
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Feld auswählen</mat-label>
                <mat-select
                  formControlName="fieldName"
                  (selectionChange)="onSecondYAxisFieldChange($event.value)"
                  [disabled]="availableFieldsForSecondYAxis.length === 0"
                  >
                  @for (field of availableFieldsForSecondYAxis; track field) {
                    <mat-option
                      [value]="field.id"
                      >
                      {{ field.label }} [{{ field.unit }}]
                    </mat-option>
                  }
                </mat-select>
                @if (secondYAxisFormGroup.get('fieldName').hasError('required')) {
                  <mat-error
                    >
                    Feld für zweite Y-Achse auswählen
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Y-Achse Beschriftung</mat-label>
                <input matInput formControlName="label" />
                @if (secondYAxisFormGroup.get('label').hasError('required')) {
                  <mat-error
                    >
                    Beschriftung für zweite Y-Achse angeben
                  </mat-error>
                }
              </mat-form-field>
              <div formGroupName="min_max" class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>Min</mat-label>
                  <input step="0.0001" type="number" matInput formControlName="min" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>Max</mat-label>
                  <input step="0.0001" type="number" matInput formControlName="max" />
                </mat-form-field>
              </div>
            </div>
          }
        </section>
      </form>
    </mat-dialog-content>

    <!-- Sticky Save Button -->
    <div class="sticky-button-container">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!correlationForm.valid || submitting"
        (click)="updateOrCreateModule()"
        class="save-button"
        >
        @if (editMode) {
          Speichern
        }
        @if (!editMode) {
          Hinzufügen
        }
      </button>
    </div>
